module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAfCAYAAADupU20AAABIUlEQVR42pzSO24CMRAGYMcSDYrCo4VUCbQUPK+yJPdImd0gcQkuwKNPeCnQcREaKto0EYwlWxqNxrtjj/QXXun/1uv1w/T7r6yU6kBOKmI0pAT5gYxiATMVyBoyjAGeELIJRQxwQ2uHDEKAM+STIFsp4s7gC5IySF8KmMkYZFeEaLL2IT0p4JCMIHsfoj1wyiDsTnTO51GkyiG64JBT+4co0pUCyt4RiuwdooUXziATbic64NrPIFe0rkESKfAMOdiSmznkQwI0bfmFlN8h/1pQPvrKRYfIvXmBy3mAK7+S8hsu+wBxmQNM+ZeUl74yBRq23CLlsa+MgYbddlDZAY8xb8ZAHdJGz1bSMneIppxIyxQILmMgquyAS8g307kLMABiYUY6n1Vt/gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/right.png
// module id = JfLI
// module chunks = 1